import BaseModel from '../../base/BaseModel.model';
export default class ResearchLine extends BaseModel {
    public fielAreaId?: string;
    public code?: string;
    public name?: string; 
    constructor(){
        super();
        this.init();
    }

    init(){
        this.fielAreaId = "";
        this.code = "";
        this.name = "";    
    }
}